module.exports = __webpack_public_path__ + "static/media/SendMoney.e4c8304d.svg";